<template>
<div class="content" id="content">
    <toolbar v-bind:selection="toolbar" v-bind:title="'Colmenar '+infoColmenar.name" action="eliminar" />

    <div v-if="!infoColmenar.name">
        <div class="card mb-3" style="padding:50px 50px 50px 50px; text-align:center">
            <p>Este colmenar <b>no existe</b> o no está disponible en este momento.</p>
            <a href="#/colmenares">Volver a colmenares</a>
        </div>
    </div>

    <div v-else>

        <v-tabs>
            <v-tabs-slider color="orange"></v-tabs-slider>

            <v-tab @click="tabs.tab1 = true; tabs.tab2 = false; tabs.tab3 = false; tabs.tab4 = false;">Colmenas ({{colmenas.length}})</v-tab>

            <v-tab @click="tabs.tab1 = false; tabs.tab2 = false; tabs.tab3 = true; tabs.tab4 = false;">Detalle</v-tab>
            <v-tab @click="tabs.tab1 = false; tabs.tab2 = false; tabs.tab3 = false; tabs.tab4 = true;">Varroa ({{varroas.length}})</v-tab>
            <v-tab @click="tabs.tab1 = false; tabs.tab2 = true; tabs.tab3 = false; tabs.tab4 = false;">Alimentación ({{feed.length}})</v-tab>
        </v-tabs>


        <div v-if="tabs.tab1===true">

            <listhives v-bind:result="colmenas" core="0" v-bind:idcolmenar="idcolmenar"></listhives>

        </div>

        <div v-if="tabs.tab2===true">

            <router-link v-bind:to="'../alimentar-colmenar/'+idcolmenar" class="btn btn-yellow">
                Añadir alimentación
            </router-link>


            <ul v-for="food in feed" :key="food.id">
                <li class="card" v-bind:id="'feed-'+food.id">
                    <div class="info-item">

                        <div class="info-item-list-left">
                            <p class="text-success"><b>{{food.date.split("-").reverse().join('-')}}</b></p>
                            <p><b>Colmenas alimentadas: </b>{{food.numberHives}}</p>
                            <p><b>Alimentación: </b>
                            <span v-if="food.food === 'sirope'">Sirope</span>
                            <span v-else-if="food.food === 'tarta'">Tarta proteina</span>
                            <span v-else-if="food.food === 'solido'">Sólido</span>
                            </p>
                            <p><b>Cantidad: </b>{{food.amount}}{{food.amount_decimal}} {{food.measure}}</p>
                            <p>{{food.note}}</p>

                        </div>

                        <div class="info-item-list-right">
                            <a v-bind:href="'#/alimentar-colmenar-editar/' + food.id">
                                <v-icon small>edit</v-icon>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>


        </div>

        <div v-if="tabs.tab3===true" class="card">
            <div class="info-item">
                <div>
                    <p class="title-box"> Colmenar {{infoColmenar.name}}</p>

                    <p v-if="infoColmenar.description"><v-icon>mdi-information</v-icon>&nbsp;{{infoColmenar.description}}</p>
                    <p v-if="infoColmenar.localization"><v-icon>mdi-map-marker</v-icon>&nbsp;{{infoColmenar.localization}}</p>
                </div>
            </div>
        </div>

        <div v-if="tabs.tab4===true">

            <v-timeline v-if="varroas.length>0">
                <v-timeline-item v-for="varroa in varroas"  :key="varroa.date">

                    <p><b>{{ varroa.date.split("-").reverse().join('-') }}</b></p>
                    <p>Test realizados: {{ varroa.tests }}</p>
                    <p><b>VARROA:</b> <span style="color:#69aa8a">{{ varroa.promedio }}</span></p>

                </v-timeline-item>

            </v-timeline>




            <div v-else class="card">
                No se han realizado test de varroas.
            </div>

        </div>




   </div>

   <menubottom active="1" />

</div>
</template>


<script>




</script>


<script>

import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import menubottom from "@/components/MenuBottom"
import listhives from "@/components/listhives"

import axios from "axios"
//import vueScrollBehavior from "vue-scroll-behavior"




export default {


   name: 'colmenar',
   components: {toolbar,menubottom,listhives},


   data() {

     return {


            tabs: {
            tab1: true,
            tab2: false,
            tab3: false,
            tab4: false,
        },
        idcolmenar: this.$route.params.id,

       toolbar: {
           return: '1',
           icons: [
             { text: 'Editar colmenar', href:'colmenar-editar/'+this.$route.params.id },
             { text: 'Eliminar colmenar', click:'delete', id:this.$route.params.id, method:'colmenar' },
             { text: 'Crear colmena/núcleo', href:'colmena-nueva/'+this.$route.params.id },
             { text: 'Cancelar', href:'colmenar/'+this.$route.params.id }
           ],
       },
       isOpen: false,
       infoColmenar: null,
       colmenas: null,
       nucleos:null,
       varroas:null,
       feed:null,
       loadingcolmenar: false,
       loadingcolmenares: false
     }
   },





   methods:{


       activate:function(el){
           this.active_el = "infoColmena"+el;
           alert(this.active_el);
       },


   },

   created() {

        auth.getUserLogged()


       var that = this
       axios.get("https://appws.panimiel.com/new/index.php/api/colmenar/"+this.$route.params.id).then((infoColmenar) => {
         that.infoColmenar = infoColmenar.data
       })

       axios.get("https://appws.panimiel.com/new/index.php/api/colmena/"+this.$route.params.id+"/2").then((colmenas) => {
         that.colmenas = colmenas.data
         that.loadingcolmenares = true
       }).catch(() => {
           that.loadingcolmenares = false
       })

    /*   axios.get("https://appws.panimiel.com/new/index.php/api/colmena/"+this.$route.params.id+"/1").then((nucleos) => {
         that.nucleos = nucleos.data
       })
*/
       axios.get("https://appws.panimiel.com/new/index.php/api/hive_varroa/colmenar/"+this.$route.params.id).then((varroas) => {
         that.varroas = varroas.data
       })

       axios.get("https://appws.panimiel.com/new/index.php/api/hive_feed/colmenar/"+this.$route.params.id).then((feed) => {
         that.feed = feed.data
       })


   }

};


</script>

<style scoped lang="scss">
</style>